import { useState } from 'react';
import logo3 from '../../Assets/logo3.png'
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isServicesDropdownOpen, setServicesDropdownOpen] = useState(false);

  return (
    <header className="bg-white shadow-lg py-4 sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between px-4">
        {/* Logo */}
        <a href="#" className="flex items-center text-primary hover:text-secondary">
        <img src={logo3} className=" w-20 bg-gradient-to-r from-black to-[#e710ea] rounded-full mr-2" />
          <span className="text-2xl font-bold bg-gradient-to-r from-black to-[#e710ea] text-transparent bg-clip-text font-['limelight']"> BULK SMS NAGPUR</span>
        </a>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <button
            onClick={() => setMobileMenuOpen(!isMobileMenuOpen)}
            className="text-gray-800 hover:text-primary focus:outline-none transition-colors duration-300"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          </button>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:block">
          <ul className="flex space-x-8">
            <li><a href="/" className="hover:text-[#e710ea] transition-colors duration-300">Home</a></li>
            <li><a href="/about" className="hover:text-[#e710ea] transition-colors duration-300">About</a></li>
            <li className="group relative">
              <a href="/service" className="hover:text-[#e710ea] transition-colors duration-300">Service</a>
            </li>
            <li><a href="/contact" className="hover:text-[#e710ea] transition-colors duration-300">Contact</a></li>
            <Link to="/contact">
  <button className=" hidden xl:block bg-gradient-to-br from-black to-[#e710ea] border-solid border-2 border-black font-bold text-white text-center cursor-pointer px-3 py-1 rounded-full">
    Follow Us
  </button>
</Link>
              </ul>
              
        </nav> 
      </div>

      {/* Mobile Menu */}
      <nav className={`md:hidden bg-gray-50 border-t border-gray-200 ${isMobileMenuOpen ? 'block' : 'hidden'}`}>
        <ul className="px-4 py-2">
          <li><a href="/" className="block py-2 hover:text-[#e710ea]">Home</a></li>
          <li><a href="/about" className="block py-2 hover:text-[#e710ea]">About</a></li>
          <li> <a href="/service" className="block py-2 hover:text-[#e710ea]">Service</a></li>
          <li><a href="/contact" className="block py-2 hover:text-[#e710ea]">Contact</a></li>
      
           </ul>
      </nav>
    </header>
  );
};

export default Header;
